import { graphqlClient } from '@/lib/graphql-client';
import { omitScopeFields } from '@/lib/scope-stamp';
import { buildGetLocationsQuery } from '../graphql/queries';
import {
  DELETE_LOCATION_MUTATION,
  INSERT_LOCATION_MUTATION,
  UPDATE_LOCATION_MUTATION,
} from '../graphql/mutations';
import {
  GetLocationsParams,
  LocationInsertInput,
  LocationsPagingResult,
  LocationUpdateInput,
} from '../types/location.types';

export const getLocations = async (
  params: GetLocationsParams
): Promise<{ Locations: LocationsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetLocationsQuery(filter, pageNo, pageSize, order),
  });
};

export const createLocation = async (input: LocationInsertInput) => {
  return graphqlClient.mutate({
    query: INSERT_LOCATION_MUTATION,
    variables: { input },
  });
};

export const updateLocation = async (params: { itemId: string; input: LocationUpdateInput }) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_LOCATION_MUTATION,
    variables: { filter, input: omitScopeFields(params.input) },
  });
};

export const deleteLocation = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_LOCATION_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
